import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction, form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherHeader } from "../../models/accvoucherheader.model";
import { VoucherInfo } from "../../models/voucherInfo.model";
import { CreateOpeningJournalVoucherFormComponent } from "../create-opening-journal-voucher-form/create-opening-journal-voucher-form.component";

@Component({
  selector: "ngx-create-opening-journal-voucher-list",
  templateUrl: "./create-opening-journal-voucher-list.component.html",
  styleUrls: ["./create-opening-journal-voucher-list.component.scss"],
})
export class CreateOpeningJournalVoucherListComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  filterInfo: NameValue[] = [];
  editingName: { name: string };
  voucherInfo: VoucherInfo = <VoucherInfo>{};
  actions: EntityListAction[];
  constructor() {
    super();
    this.inputEditorform = CreateOpeningJournalVoucherFormComponent;
  }
  ngOnInit() {
    this.apiName = "AccVoucherHeader";
    this.areaName = "Accounting";
    this.label = this.translate("ClientApp.BackOffice.ACC.AccCloseProfitandLossAccountsHeader.CreateOpeningJournalVoucher");
    super.ngOnInit();
    this.setColumns();
    this.setactions();
    if (this.accountService.authService.currentFiscalYear) {
      this.voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear?.Id;
      this.voucherInfo.BranchId = this.accountService.authService.currentBranchId;
      this.getVoucher();
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.voucherInfo.FiscalYearId = x.Id;
          this.voucherInfo.BranchId = this.accountService.authService.currentBranchId;
          this.getVoucher();
        }
      });
  }
  getVoucher() {
    if (this.loadingIndicator === true) return;
    this.loadingIndicator = true;
    this.httpCommonService
      .create("AccCloseProfitandLossAccountsHeader/GetOpeningJournalVoucher", this.voucherInfo)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.loadingIndicator = false;
          if (data != undefined) {
            this.dataList = data as AccVoucherHeader[];
          }
          setTimeout(() => (this.loadingIndicator = false), 1000);
        },
        (error) => {
          this.loadingIndicator = false;
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در بارگذاری اطلاعات");
        }
      );
  }
  setactions() {
    this.actions = [
      {
        name: "CreateOpeningJournalVoucher",
        disabled: false,
        displayName: "سند افتتاحیه",
        iconName: "icon-file-document-multiple-outline",
        apiName: "AccCloseProfitandLossAccountsHeader/CreateOpeningJournalVoucher",
        areaName: "Accounting",
        Form_Component: CreateOpeningJournalVoucherFormComponent,
        permission: Permission.samePermission,
      },
    ];
  }
  setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.columns = (data as form_control[]).sort((a, b) => a.order - b.order);
        }
      });
  }
}
